/**
 * Existing customers, quoted from the old CustomerSays section.
 *
 * The barbershop quote (מספרת סטאציו) was dropped with the retarget to
 * studios — a barber testimonial on a pilates page works against the
 * positioning. It is still in git history if you want it back. A third studio
 * quote would round this row out nicely.
 */

export const testimonials = [
  {
    name: "וי פיט",
    role: "סטודיו לכושר",
    avatar: require("@/assets/wfc.jpg"),
    quote:
      "מרגישה שליטה בסטודיו, האפליקציה מנהלת לי את הלו״ז והמדידות, תמיד מעודכנת במנויים ובמספר האימונים השבועי לכל מתאמנת.",
  },
  {
    name: "סאמיה פיטנס",
    role: "סטודיו לאימונים",
    avatar: require("@/assets/samya.jpg"),
    quote:
      "בונה את קבוצות האימון כמה ימים מראש, המתאמנות מצטרפות בשעה שמתאימה להן. הכל מנוהל באפליקציה — מדידות גוף ומעקב אחרי הכרטיסיות.",
  },
];
